import { Pipe, PipeTransform } from '@angular/core';
import { TinyHelpers } from '@coin/shared/core/util-helpers';

@Pipe({
  name: 'capitalize',
  standalone: true
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    return TinyHelpers.capitalize(value);
  }
}
